<template>
  <div>
    <div v-if="!loaded_basic_info" class="row">
      <div class="col-12">
        <order_loader :loadingMessage="'BASIC INFO'"></order_loader>
      </div>
    </div>
    <div v-else class="row">
      <div v-if="ms_opts.companies.length > 0" class="col-12">
        <!--  <div class="col-12">-->
        <b-card body-class="mb-3 pb-2 pt-3">
          <ValidationObserver ref="orderBasicInfoForm" slim>
            <form role="form" @submit.prevent="order_basic_info_submit">
              <div class="row">
                <!-- Date of Order -->
                <ValidationProvider rules="required" v-slot="{errors, classes}" name="Order Date" tag="div" class="col-xl-4 form-group">
                  <label class="form-label" for="order_date">Order Date</label>
                  <datepicker v-model="basic_info.date_of_order" id="order_date" name="order_date" :input-class="['date-input', 'requiredField', classes]"
                              :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times" @input="select_order_date" :use-utc="true"></datepicker>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <!-- Order Consultant -->
                <ValidationProvider rules="required" v-slot="{errors, classes}" name="Order Consultant" tag="div" class="col-xl-4 form-group">
                  <label class="form-label" for="order_consultant">Order Consultant</label>
                  <multiselect v-model="basic_info.consultant" track-by="id" id="order_consultant" class="requiredField" :class="classes" name="employment_type"
                               label="name" placeholder="" :options="ms_opts.crm_users" :custom-label="consultant_label"></multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <!-- Company -->
                <ValidationProvider rules="required" v-slot="{errors, classes}" name="Company" tag="div" class="col-xl-4 form-group">
                  <label class="form-label" for="order_company">Company</label>
                  <multiselect 
                    v-model="basic_info.company" 
                    track-by="id" 
                    id="order_company" 
                    class="requiredField" 
                    :class="classes" 
                    name="order_company"
                    label="company_name" 
                    placeholder="" 
                    :options="ms_opts.companies" 
                    :disabled="companyDisabled"
                    @input="select_company">
                  </multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <!-- Type -->
                <ValidationProvider rules="required" v-slot="{errors, classes}" name="Order Type" tag="div" class="col-xl-4 form-group">
                  <label class="form-label" for="order_type">Order Type</label>
                  <multiselect v-model="basic_info.type" id="order_type" class="requiredField" :class="classes" name="order_type"
                               placeholder="" :options="ms_opts.order_type" label="value"></multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>

                </ValidationProvider>
                <!-- Status -->
                <ValidationProvider rules="required" v-slot="{errors, classes}" name="Order Status" tag="div" class="col-xl-4 form-group">
                  <label class="form-label" for="order_status">Order Status</label>
                  <multiselect v-model="basic_info.status" id="order_status" class="requiredField" :class="classes" name="order_status"
                               placeholder="" :options="ms_opts.order_status"></multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <!-- GM Solution (PAYROLL ONLY) -->
                <ValidationProvider
                    v-if="show_project_managed_fields"
                    rules="required" v-slot="{errors, classes}" name="Solution" tag="div" class="col-xl-4 form-group">
                  <label class="form-label" for="payroll_solution">Solution</label>
                  <multiselect v-model="basic_info.payroll_solution" id="payroll_solution" class="requiredField" :class="classes" name="payroll_solution"
                               placeholder="" :options="ms_opts.payroll_client_solution" label="value" @select="payroll_solution_select"></multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <!-- GM Project Manager (PAYROLL ONLY) -->
                <ValidationProvider v-if="show_project_managed_fields && show_project_manager" rules="required" v-slot="{errors, classes}" name="Genius Project Manager" tag="div"
                                    class="col-xl-4 offset-xl-8 form-group">
                  <label class="form-label" for="project_manager">Project Manager</label>
                  <multiselect v-model="basic_info.project_manager" track-by="id" id="project_manager" class="requiredField" :class="classes" name="project_manager"
                               label="name" placeholder="" :options="ms_opts.crm_users" :custom-label="consultant_label"></multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- JOB CONTACT -->
              <div v-if="company_selected" class="row">
                <div class="col-12">
                  <hr class="mt-3 mb-3">
                </div>
                <div class="col-6">
                  <h4>Job Contact</h4>
                </div>
                <div class="col-6">
                  <button @click.prevent="add_contact" class="btn orcaBtn blueBtn sm_btn float-right mb-3">Add company contact</button>
                </div>
                <!-- Job Contact -->
                <ValidationProvider rules="required" v-slot="{errors, classes}" name="Job Contact" tag="div" class="basic_order_info col-xl-6 form-group">
                  <label class="form-label" for="job_contact">Job Contact</label>
                  <multiselect v-model="basic_info.job_contact" placeholder="" id="job_contact" label="contact_label" track-by="id" :options="ms_opts.job_contacts"
                               :option-height="200" :custom-label="contact_label" :show-labels="false" class="requiredField" :class="classes">
                    <template slot="singleLabel" slot-scope="props">
                        <span class="option__desc_single">
                          <span class="option__title">{{ job_contact_name_format(props) }}</span>
                        </span>
                    </template>
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <span class="option__title">{{ job_contact_name_format(props) }}</span>
                        <span class="option__small">{{ job_contact_job_title_format(props) }}</span>
                      </div>
                    </template>
                  </multiselect>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <!-- Job Contact - Job Title -->
                <div class="col-xl-6 form-group">
                  <label class="form-label" for="job_contact_job_title">Job Contact: Job Title</label>
                  <input v-if="isContactSelected && contactHasJobTitle" type="text" v-model="basic_info.job_contact.rel_profile.job_title.job_title"
                         id="job_contact_job_title" name="'job_contact_job_title" class="form-input disabled" readonly>
                  <input v-else type="text" id="null_job_contact_job_title" name="'null_job_contact_job_title" class="form-input disabled" readonly>
                </div>
                <!-- Job Contact - Work Mobile -->
                <ValidationProvider :rules="{ 'required' : isMobileRequired }" v-slot="{errors, classes}" name="Job Contact: Mobile" tag="div" class="col-xl-3 form-group">
                  <label class="form-label" for="job_contact_mobile">Job Contact: Mobile</label>
                  <input v-if="isContactSelected" type="text" v-model="basic_info.job_contact.phones.work_mobile" id="job_contact_mobile"
                         name="'job_contact_mobile" class="form-input disabled" :class="classes" readonly>
                  <input v-else type="text" id="null_job_contact_mobile" name="'null_job_contact_mobile" class="form-input disabled" readonly>
                  <div v-if="errors[0]" class="vvERROR">The Job Contact: Mobile or Landline Phone field is required</div>
                </ValidationProvider>
                <!-- Job Contact - Work Landline -->
                <ValidationProvider :rules="{ 'required' : isPhoneRequired }" v-slot="{errors, classes}" name="Job Contact: Landline Phone" tag="div" class="col-xl-3 form-group">
                  <label class="form-label" for="job_contact_phone">Job Contact: Landline Phone</label>
                  <input v-if="isContactSelected" type="text" v-model="basic_info.job_contact.phones.work_landline" id="job_contact_phone"
                         name="'job_contact_phone" class="form-input disabled" :class="classes" readonly>
                  <input v-else type="text" id="null_job_contact_phone" name="'null_job_contact_phone" class="form-input disabled" readonly>
                  <div v-if="errors[0]" class="vvERROR">The Job Contact: Mobile or Landline Phone field is required</div>
                </ValidationProvider>
                <!-- Job Contact - Work Email -->
                <ValidationProvider rules="required" v-slot="{errors, classes}" name="Job Contact: Email" tag="div" class="col-xl-6 form-group">
                  <label class="form-label" for="job_contact_email">Job Contact: Email</label>
                  <input v-if="isContactSelected" type="text" v-model="basic_info.job_contact.emails.work_email" id="job_contact_email" :class="classes"
                         name="'job_contact_email" class="form-input disabled" readonly>
                  <input v-else type="text" id="null_job_contact_email" name="'null_job_contact_email" class="form-input disabled" :class="classes" readonly>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
              </div>
              <!-- show if not company has been selected -->
              <div v-else class="row">
                <div class="col-12">
                  <hr class="mt-3 mb-3">
                </div>
                <div class="col-6">
                  <h4>Job Contact</h4>
                </div>
                <div class="col-12">
                  <h5 class="red_color">You must select a Company and then select a Job Contact</h5>
                </div>
              </div>
              <!-- SAVE BUTTON -->
              <div class="row">
                <div class="col-12">
                  <hr class="mt-3 mb-0">
                </div>
                <div class="col-xl-6 offset-xl-6">
                  <button class="btn orcaBtn mt-3">Save Basic Order Information</button>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </b-card>
      </div>
      <div v-else class="col-12">
        <h4 class="font-weight-bold red_color mb-0 text-uppercase">There are no Live/Active Companies within the system to raise an order for.</h4>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';
import order_loader from "loaders/order_loader";
import _ from 'lodash';

export default {
  name: "basic_info",
  components: {
    Multiselect,
    Datepicker,
    order_loader
  },
  props: ['order_action'],
  data() {
    return {
      ms_opts: {
        crm_users: [],
        companies: [],
        order_type: [],
        order_status: [],
        payroll_client_solution: this.$store.state.crm_options.payroll_client_solution,
        job_contacts: [],
      },
      basic_info: {
        date_of_order: null,
        consultant: null,
        company: null,
        type: null,
        status: null,
        payroll_solution: null,
        project_manager: null,
        job_contact: null
      },
      loaded_basic_info: false,
      companyDisabled: false,  // To control whether the company field is disabled
    }
  },
  computed: {
    show_project_managed_fields() {
      return this.basic_info?.type && (this.basic_info?.type?.value.toLowerCase() === 'payroll - contract' || this.basic_info?.type?.value.toLowerCase() === 'payroll - paye');
    },
    /**
     * Show or hide project manager multiselect
     * @returns {boolean}
     */
    show_project_manager() {
      return (this.basic_info.payroll_solution !== undefined && this.basic_info.payroll_solution !== null
          && this.basic_info.payroll_solution.value === 'Project Managed Labour Solutions')
    },
    /**
     * Show job contact entry once company selected
     * @returns {boolean}
     */
    company_selected() {
      return this.basic_info.company !== null
    },
    /**
     * trigger for reloading company contacts
     * @returns {boolean|*}
     */
    contact_reload() {
      return this.$store.state.contacts.reload_contacts;
    },
    /**
     * If there is a job contact selected
     * @returns {boolean}
     */
    isContactSelected() {
      return this.basic_info.job_contact !== null
    },
    /**
     * If the job contact selected has a job title
     * @returns {boolean}
     */
    contactHasJobTitle() {
      return this.basic_info.job_contact.rel_profile.job_title_id !== null
    },
    /**
     * check if landline is required (contact doesn't have mobile)
     * @returns {boolean|boolean}
     */
    isPhoneRequired() {
      return this.basic_info.job_contact !== null ? this.basic_info.job_contact.phones.work_mobile === null : false;
    },
    /**
     * Check if mobile is required (contact doesn't have landline)
     * @returns {boolean|boolean}
     */
    isMobileRequired() {
      return this.basic_info.job_contact !== null ? this.basic_info.job_contact.phones.work_landline === null : false;
    }
  },
  beforeMount() {
    // load initial data for order step
    this.load_data().then(() => this.loaded_basic_info = true);
  },
  watch: {
    show_project_managed_fields: function (newValue) {
      if(!newValue) {
        this.basic_info.project_manager = null;
        this.basic_info.payroll_solution = null;
      }
    },
    'basic_info.type'(newValue) {
      if (newValue) {
        if (newValue.id === 81) { // 81 - "Internal" in gm orca
          const internalCompany = this.ms_opts.companies.find(company => company.id === 234); // 234 - GENIUS MONEY LIMITED
          if (internalCompany) {
            this.basic_info.company = internalCompany;
            this.select_company();
            this.companyDisabled = true;
          }
        } else if (newValue.id === 73) { // 73 - "Internal" in V3 orca
          const internalCompany = this.ms_opts.companies.find(company => company.id === 7167); // 7167 - V3 Recruitment Limited
          if (internalCompany) {
            this.basic_info.company = internalCompany;
            this.select_company();
            this.companyDisabled = true;
          }
        } else {
          this.companyDisabled = false;
        }
      } else {
        this.companyDisabled = false;
      }
    },
    /**
     * Reload company contacts on trigger
     * @param val
     */
    contact_reload(val) {
      if (val === true) {
        this.basic_info.job_contact = null;
        this.get_company_contacts()
      }
    },
    /**
     * Watch for when a company contact is selected
     * check if required contact information exists
     * @param contact
     */
    'basic_info.job_contact'(contact) {
      if (contact !== null) {
        // if contact has no email address or if contact has no phone number and no mobile number
        if (contact.emails.work_email === null || (contact.phones.work_landline === null && contact.phones.work_mobile === null)) {
          // show edit contact modal - to fill in missing information
          this.$store.commit('SHOW_EDIT_CONTACT_MODAL', {
            contact_id: contact.id,
            company_id: contact.company_id,
          });
          this.$nextTick(() => this.$root.$emit('bv::show::modal', 'edit_contact_modal'))
        }
      }
    }
  },
  methods: {
    /**
     * Load data for the order step
     * multiselect's and data from vuex if order step already completed once
     * @returns {Promise<Awaited<unknown>[]>}
     */
    load_data() {
      let load_promises = [];
      // get all users who can be a consultant for the order being raised
      load_promises.push(new Promise(resolve => {
        axios.get(this.crmApiPath + 'user/index-has-role', {
          params: {
            role: 'consultant_order',
          }
        })
        .then(crm_users => {
          this.ms_opts.crm_users = crm_users.data;
          resolve();
        });
      }))
      // get all companies that can have an order raised for them (Live and Active status)
      load_promises.push(new Promise(resolve => {
        axios.get(this.crmApiPath + 'company/all/order').then(companies => {
          this.ms_opts.companies = companies.data

          // Pre-select company - if arrive from company record
          if (this.$store.state.orders.create_order_company_id !== null) {
            this.basic_info.company = this.ms_opts.companies.find(c => c.id === this.$store.state.orders.create_order_company_id);
            // get company contacts
            this.$nextTick(() => this.select_company());
          }

          resolve();
        })
      }))
      // set loaded/initial values for order step
      load_promises.push(new Promise(resolve => {
        // If is a partially complete order load information stored in vuex
        if (this.$store.state.orders.order_steps.basic_info.partial_order_complete) {
          this.basic_info = this.$store.state.orders.order_steps.basic_info.data;
          this.$nextTick(() => this.select_company());
        }

        // Depending on CRM Type - list order options TODO (REVIEW FOR RESOURCING @ GENIUS)
        if (this.crmType === 'payroll') {
          this.ms_opts.order_type = this.$store.state.crm_options.payroll_order_type;
        }
        else if (this.crmType === 'recruitment') {
          this.ms_opts.order_type = this.$store.state.crm_options.recruitment_order_type;
        }
        // Order status options/Date of order - depending on whether it is a New/Copy/Edit order
        if (this.order_action === 'create') {
          // options
          this.ms_opts.order_status = ['Live', 'Dummy'];
          // values
          this.basic_info.date_of_order = this.$moment.utc().format('YYYY-MM-DD');
          this.basic_info.status = 'Live';
        }
        else if (this.order_action === 'edit') {
          this.ms_opts.order_status = ['Live', 'Dummy', 'Filled', 'Lost'];
        }
        else if (this.order_action === 'copy') {
          this.ms_opts.order_status = ['Live', 'Dummy'];
          this.basic_info.status = 'Live';
        }
        resolve();
      }))
      return Promise.all(load_promises);
    },
    /**
     * get contacts for a selected company (or loaded company from vuex)
     * @returns {Promise<AxiosResponse<any>>}
     */
    get_company_contacts() {
      return axios.get(this.crmApiPath + 'contact/company/' + this.basic_info.company.id)
                  .then(contacts => this.ms_opts.job_contacts = contacts.data)
    },
    /*
     * ******************************************
     * first section
     * ******************************************
     */
    /**
     * Date Format for datepicker
     * @param date
     * @returns {string}
     */
    dateFormat(date) {
      return this.$moment.utc(date).format("DD/MM/YYYY");
    },
    /**
     * When selecting the order date, if not null then set date to formatted selection from datepicker
     * @param order_date
     */
    select_order_date(order_date) {
      if (order_date != null) {
        this.basic_info.date_of_order = this.$moment.utc(order_date).format('YYYY-MM-DD');
      }
    },
    /**
     * Return formatted consultant name for multiselect options
     * order consultant && project manager
     * @param first_name
     * @param surname
     * @returns {string}
     */
    consultant_label({first_name, surname}) {
      return `${first_name} ${surname}`;
    },
    /**
     * Selection of the company from multiselect (or when data is being loaded)
     * load company contacts and set information for the company selected
     */
    select_company() {
      // if information is not being loaded from the vuex store (first time on the order step)
      if (!this.$store.state.orders.order_steps.basic_info.partial_order_complete) {
        // set job contact to null when selecting a company - ensuring contacts from different company aren't selected
        this.basic_info.job_contact = null;
      }
      // if there is a company selected
      if (this.basic_info.company !== null) {
        // if the crm is for genius and the data is not being loaded from the vuex store
        if (this.crmType === 'payroll' && !this.$store.state.orders.order_steps.basic_info.partial_order_complete) {
          // get the payroll solution for the company (set on their record) and set on order
          axios.get(this.crmApiPath + 'company/payment_process_info/company/' + this.basic_info.company.id)
               .then(payment_process_info => {
                 this.basic_info.payroll_solution =
                     this.$store.state.crm_options.payroll_client_solution.find(pcs => pcs.id === payment_process_info.data.payroll_solution_id)
               })
        }
        // populate company contacts multiselect options
        this.get_company_contacts();
      }
    },
    /**
     * Action when the payroll solution is selected
     * @param payroll_solution
     */
    payroll_solution_select(payroll_solution) {
      // if there is a payroll solution provided to the function, and it is not 'Project managed..'
      if (payroll_solution === null || payroll_solution !== 'Project Managed Labour Solutions') {
        // clear project manager data
        this.basic_info.project_manager = null;
      }
    },
    /*
     * ******************************************
     * job contact section
     * ******************************************
     */
    /**
     * show modal to add job contact
     */
    add_contact() {
      this.$store.commit('SHOW_ADD_CONTACT_MODAL', {
        company_id: this.basic_info.company.id,
        company_name: this.basic_info.company.company_name
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'add_contact_modal'));
    },
    /**
     * Format options for company contact multiselect options
     * @param person
     * @returns {string}
     */
    contact_label({person}) {
      return `${person.first_name} ${person.surname}`;
    },
    /**
     * Format job contact name
     * @param props
     * @returns {string}
     */
    job_contact_name_format(props) {
      return props.option.person.first_name + ' ' + props.option.person.surname
    },
    /**
     * Return job contact job title for multiselect - if they have one set
     * @param props
     * @returns {string|*}
     */
    job_contact_job_title_format(props) {
      return props.option.rel_profile.job_title_id !== null ? props.option.rel_profile.job_title.job_title : "";
    },
    /*
     * ******************************************
     * Order step submission
     * ******************************************
     */
    order_basic_info_submit() {
      this.$refs.orderBasicInfoForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.orderBasicInfoForm);
          // store values to vuex if there were errors
          this.$store.commit('SAVE_BASIC_INFO_ERRORS', this.basic_info);
        }
        else {
          // store values to vuex on successful submit
          this.$store.commit('SAVE_BASIC_INFO_COMPLETED', this.basic_info);
        }
      });
    }
  }
}
</script>
